import { SkillResponse } from './skillresponse';
import { VerticalSkillRespose } from './VerticalSkillRespose';

export class CompanySkillWrapper {
    public success: boolean = false;
    public successMessage: any;
    public errorCode: any;
    public errorMessage: any;
    public pageNumber: any;
    public pageSize: any;
    public resultSize: any;
    public skillResponses: SkillResponse[] = [];
    public verticalSkillResposes: VerticalSkillRespose[] = [];
}
